import store from '@/store'
import Vuex from 'vuex'
import axios from 'axios'
import Timer from '@/components/Base-Timer.vue'
import Reloj from '@/components/CronometroTimer.vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification';


export default {
    name: "my-tour",
    components: {
        Timer,
        Reloj
    }, data() {
        return {
            numberpreguntas: this.$store.state.numerpreguntas,
            IdExamenTeorico: this.$store.state.IdExamenTeorico,
            NUMBER_PREGUNTAS: 40,
            width: '',
            height: '',
            resolution: '',
            idAspirante: Number,
            format: '',
            activeStep: 0,
            isActive: true,
            step: 1,
            picked: [],
            numberPhotos: null,
            currentQuestion: 0,

            //Opciones para tarjetas de las ayudas al iniciar el examen (Vue-tour)
            options: {
                labels: {

                    //Botones para desplazar las ayudas (Vue-tour)
                    buttonNext: 'SIGUIENTE',
                    buttonStop: 'INGRESO EXAMEN'
                }
            },
            //Ciclo de vida del Vue-tour 
            callbacks: {
                onNextStep: this.myCustomNextStepCallback,
                onStop: this.onFinish,
            },
            //Ayudas que se muestran antes de iniciar el examen (Vue-tour)
            steps: [
                {
                    target: '.v-step-0',  // Selección de clases para las ayudas
                    header: {
                        title: 'Ayuda'
                    },
                    params: {
                        placement: 'left' // Para modificar  https://popper.js.org/popper-documentation.html#Popper.placements
                    },
                    content: `En la parte superior derecha encontrarás el tiempo restante de la prueba tanto de forma numérica como en forma circular de progreso.`
                },
                {
                    target: '.v-step-1',
                    header: {
                        title: 'Ayuda',
                    },
                    params: {
                        placement: 'bottom'
                    },
                    content: 'Entre los botones de navegación, se encuentra la numeración de preguntas. Puedes dirigirte a una pregunta haciendo clic sobre el círculo para responder preguntas. Puedes avanzar sin responder y regresar a una pregunta más tarde.'
                },
                {
                    target: '.v-step-2',
                    header: {
                        title: 'Ayuda',
                    },
                    params: {
                        placement: 'right'
                    },
                    content: 'Inferior a la parte del encabezado encontrarás el cuerpo de la pregunta. Allí verás el número de la pregunta actual y sus opciones de respuesta.'
                },

                {
                    target: '.v-step-3',
                    header: {
                        title: 'Ayuda',
                    },
                    params: {
                        placement: 'top'
                    },
                    content: 'Al lado de los bullets de respuesta encontrarás los botones de navegación que te permitirán desplazarte entre las preguntas del examen.'
                },
                {
                    target: '.v-step-4',
                    header: {
                        title: 'Ayuda',
                    },
                    params: {
                        placement: 'bottom'
                    },
                    content: 'En la parte inferior de las respuestas encontrarás el botón “FINALIZAR EXAMEN” el cual te mostrará un resumen de tus preguntas respondidas y te pedirá confirmar la finalización del examen.'
                }
            ],
            //
        }
    },
    computed: {
        
        //Conexión con getters del store
        ...Vuex.mapGetters(['validateQuestionResponses']),

        //Mensaje finalización de examen
        showFinalizationMessage() {
            return this.store.state.btnFinalizar === 2 && (this.store.state.contadorPreguntas === this.store.state.numerpreguntas || this.step === this.store.state.numerpreguntas + 1);
          },
          
          isExamStarted() {
            return store.state.inicioExamen !== 0
        },

    },
    setup() {
        //Uso del store
        const store = useStore();
        const toast = useToast();
        return {
            store, toast
        }
    },
     created() {
        window.addEventListener('beforeunload', ev =>{
            ev.returnValue =
            'Estas seguro de cerrar'
            return;
          }
           );


    },
    async mounted() {

        const {
            numero: numberPhotos,
            resolucion,
            formato,
            idAspirante } = await this.getPhotoParameters();

        this.numberPhotos = numberPhotos;
        this.format = formato;
        this.idAspirante = idAspirante;
        this.resolution = resolucion;
        //
        this.setRandomPhotos(this.$store.state.numerpreguntas, this.numberPhotos);
        const { width, height } = this.setResolution(this.resolution);
        this.width = width;
        this.height = height;


        //Deshabilitar retroceso en la ventana del navegador
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button" //chrome
        window.onhashchange = function () { window.location.hash = ""; }
          
        this.$store.commit('setTextoHeader', 3);
        this.$store.commit('setBtnFinalizar', 0);
        this.$tours['myTour'].start();
        const constraints = (window.constraints = {
            audio: false,
            video: true,
            image: "",
        });
        //
        navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
                this.$refs.camera.srcObject = stream;
            })
            .catch(error => {
                alert(`Para iniciar la prueba debe encender su cámara `);
                console.log(error)
            });
    },
    methods: {

            //Tipo de archivo para las preguntas
        isFileType(file, type) {
            if (type === 'image') {
              return /\.(gif|png|jpe?g)$/.test(file);
            } else if (type === 'video') {
              return /\.(mp4|mov|wmv|avi|mkv)$/.test(file);
            } else if (type === 'audio') {
              return /\.(mp3|wav|wma)$/.test(file);
            }
          },

            //Volver a la primera pregunta 
        volverPrueba() {
            this.$store.commit('setBtnFinalizar', 0);
            this.step = 1;
        },

        mediaType(url) {
            const imageTypes = ['gif', 'png', 'peg', 'jpg'];
            const videoTypes = ['mp4', 'mov', 'wmv', 'avi','mkv'];
            const audioTypes = ['mp3','wav','WMA']
            const fileType = url.substring(url.length - 3);
            if (imageTypes.includes(fileType)) return 'img';
            if (videoTypes.includes(fileType)) return 'video';
            if (audioTypes.includes(fileType)) return 'audio';
          },
        


        buttonsFunction(){
            this.enviarRespuesta();
            this.questionsAnswers();
        },

        //Recuperar respuestas seleccionadas
            questionsAnswers(){
                setTimeout(() => {
                    const responses = this.$store.state.questionResponses;
                    const answers = document.getElementsByClassName('form-check-input');
                    for (let i = 0; i < answers.length; i++) {
                        const answerValue = answers[i].value;
                        const [, IdRespuesta] = answerValue.split(',');
                        const respon = responses.find(item => item.IdRespuesta === Number(IdRespuesta));
                        if (respon) {
                            answers[i].click();
                        }
                    }
                }, 500);
                
            },
        

        //  questionsAnswers() {

        //     // debugger;
        //     if(this.step +1  || this.step -1){
        //         const responses = this.$store.state.questionResponses;
        //         const answers = document.getElementsByClassName('form-check-input');
        //         for (let i = 0; i < answers.length; i++) {
        //           const answerValue = answers[i].value;
        //           const [, IdRespuesta] = answerValue.split(',');
        //           const respon = responses.find(item => item.IdRespuesta === Number(IdRespuesta));
        //           if (respon) {
        //             answers[i].click();
        //           }
        //         }            
    
        //     }
        // },
       
        //Finalizar Examen
        finishExam() {
            // document.getElementById('steps').classList.remove('current');
            this.enviarRespuesta();
            this.getDateFinish();
            this.$store.commit('setBtnFinalizar', 2);

        },

        //Obtener resolución para las fotos
        setResolution(photoResolution) {
            let resolution = photoResolution.split("x");
            return { width: resolution[0], height: resolution[1] }
        },

        //Número de preguntas random para toma de fotos 
        setRandomPhotos(maxValue, numberPhotos) {
                    const min = 3;
                    const max = Math.floor(maxValue);
                    for (let i = 0; i < numberPhotos; i++) {
                        let randomQuestion = Math.floor(Math.random() * (max - min + 1))
                        // console.log('randomQuestion',randomQuestion)
                        store.commit('setRandomQuestions', randomQuestion)
                        if (this.$store.state.randomQuestions.includes(randomQuestion) && randomQuestion === 0) {
                            i--
                        } else {
                            store.commit('setRandomQuestions', randomQuestion)
                        }
                    }
        },
        

         //Servicio de parámetros de fotos
        async getPhotoParameters() {
            try {
                const { data } = await axios.get(
                    "https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-parametros-ANSV/parametrizacion-foto"
                )
                return data[0]
            } catch ($error) {
                console.log($error, 'An error has ocurred');
            }
        },

        //Servicio para almacenar fotos 
        async sendPhotoEvidence(urlEvidence, idAspirante) {
            // console.log(urlEvidence, idAspirante, 'sdas');
            let body = {
                "IdExamenSesion": 3,
                "IdAspirante": idAspirante,
                "FechaRegistroEvidencia": "2022-07-29",
                "UrlEvidencia": urlEvidence
            }

            try {
                await fetch(
                    "https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-evidencia-examen-teorico/evidencia-examen-teorico", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                });
            } catch ($error) {
                console.log($error, 'An error has ocurred');
            }
        },

        fileRandomName(format) {
            return `${(Math.random() + 1).toString(36).substring(7)}.${format.toLowerCase()}`;
        },

        //Usar cámara para toma de foto
        getCanvasBlob(canvas) {
            return new Promise(function (resolve) {
                canvas.toBlob(function (blob) {
                    resolve(blob);
                })
            })
        },
        //Tomar foto
        takePhoto() {
            const FLASH_TIMEOUT = 50;
            const DOWNLOAD_TIMER = 1000;
            const isShotPhoto = true;

            if (isShotPhoto) {
                setTimeout(() => { this.isShotPhoto = !this.isShotPhoto; }, FLASH_TIMEOUT);
            }
            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
            setTimeout(this.sendPhoto, DOWNLOAD_TIMER);
        },

        //Guardar url de foto para enviar como evidencia de examen
        saveUrlEvidence(urlPhotosEvidence) {
            this.$store.commit('addUrlEvidence', urlPhotosEvidence);
            console.log("esta es la url de foto",urlPhotosEvidence)
        },

        //
        setPreguntas(numberQuestions) {
            this.store.commit('setPreguntas', numberQuestions);
        },

        myCustomNextStepCallback(currentStep) {
            this.activeStep = currentStep + 1;
            if(this.activeStep === 4){
                this.$store.commit('setInicioExmen', 1)
                // var element = document.getElementById("v-step-1");
                // element.classList.remove("not-active");
            }

    
        },

        onFinish() {
            this.activeStep += 1;
        },

        addStep(stepper, isNormal) {
            if (!isNormal) {
                this.step = stepper;
                this.step === 0 ? this.step = 1 : this.step = stepper;
            } else {
                this.step += stepper;
            }
            this.$store.state.randomQuestions.includes(this.step) ? this.takePhoto() : this.$store
        },

        //Servicio para guardar foto
        async sendPhoto() {
            let data = new FormData();
            const canvas = document.getElementById("photoTaken");
            let canvasBlob = await this.getCanvasBlob(canvas);
            data.append('File', canvasBlob, this.fileRandomName(this.format));
            console.log(data)
            try {
                const response = await fetch("https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-multimedia/guardar-foto", {
                    method: "POST",
                    body: data,
                    headers: {
                        'Accept': 'application/json',
                    },
                });
                const urlEvidence = await response.text();
                await this.sendPhotoEvidence(urlEvidence, this.idAspirante);
                await this.saveUrlEvidence(urlEvidence);
            } catch ($error) {
                console.log($error, 'An error has occurred');
            }
        },

        //Servicio para almacenar respuesta seleccionada
        async enviarRespuesta() {
            // this.$store.commit('setBtnFinalizar' , 0)

            let numberPreguntas = this.$store.state.numerpreguntas + 1
            if( this.step === numberPreguntas ){
                this.$store.commit('setBtnFinalizar' , 2)
                this.getDateFinish();
            }
           
            const getQuestions = async () => {
                let IdBancoPregun = this.picked[0];
                try {
                    if (this.picked) {
                        if (this.$store.getters.validateResponses(IdBancoPregun)) {
                            
                            let responses = this.$store.state.responses;
                            const result = responses.find(response => response.IdBancoPregun === IdBancoPregun);
                            console.log(result);
                            
                            // if(result){
                            //     return  result.IdBancoPregunta;
                            // }

                            let json = {
                                "IdRespuestaExamenTeorico": result.IdData,
                                "IdRespuesta": this.picked[1],
                                "IdBancoPregun": this.picked[0],
                                "IdExamenEjecucion": this.$store.state.idExamenEjecucion
                            };
                            const respuesta = await axios.post('https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-examen-teorico/examen-teorico/respuesta', json)
                            this.estatus = respuesta.status
                            console.log(respuesta.data);
                            if (respuesta.status === 200) {
                                this.validateQuestionResponse({ "IdBancoPregun": this.picked[0], "IdRespuesta": this.picked[1] });
                                this.saveResponse({ "IdBancoPregun": this.picked[0], "IdRespuesta": this.picked[1], "IdData" : respuesta.data });
                            }
                        }
                        else {
                            let json = {
                                "IdRespuestaExamenTeorico": 0,
                                "IdRespuesta": this.picked[1],
                                "IdBancoPregun": this.picked[0],
                                "IdExamenEjecucion": this.$store.state.idExamenEjecucion
                            };
                            const respuesta = await axios.post('https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-examen-teorico/examen-teorico/respuesta', json)
                            this.estatus = respuesta.status
                            console.log(respuesta.data);
                            if (respuesta.status === 200) {
                                this.validateQuestionResponse({ "IdBancoPregun": this.picked[0], "IdRespuesta": this.picked[1] });
                                 this.saveResponse({ "IdBancoPregun": this.picked[0], "IdRespuesta": this.picked[1], "IdData" : respuesta.data });
                            }
                        }


                    }
                } catch ($error) {
                    console.log($error, "An error has occurred")
                }
                this.picked = "";
                this.idPregun = "";
            };
            // getQuestions();
            !!this.picked[0] && !!this.picked[1]  ? getQuestions() : console.log('ok');
        },

        //Servicio para almacenar examen en base de datos
        async saveExam(){
            let datosEjecucion = this.$store.state.questionResponses;
            let evidenciaTeorico = this.$store.state.urlPhotosEvidence;

            let json = {
                "IdExamenEjecu": this.$store.state.idExamenEjecucion,
                "DatosEjecucion": JSON.stringify(datosEjecucion),
                "FechaInicio": this.$store.state.fechaInicio,
                "FechaFin": this.$store.state.fechaFin,
                "Estado": "Pendiente de calificacion",
                "ExamenCompletado": this.$store.state.examenCompletado,
                "IdExamenResultado": 1,
                "EvidenciaTeorico": JSON.stringify(evidenciaTeorico),
                "IdExamenTeorico": this.$store.state.idExamenTeorico
            }

            let idUsuario = this.$store.state.idUsuario;
            let fechaFinSesion = this.$store.state.fechaFinSesion;
            try {
                const data = await axios.put(
                    `https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-examen-ejecucion/examen-ejecucion/${idUsuario}/${fechaFinSesion}`, json
                    
                );
                // console.log(data)
                this.$router.push('/fin-examen')
                this.$store.commit('setBtnFinalizar', 3)
                if (data.status === 200) {
                    let data =  {
                         "IdExamenEjecu" : this.$store.state.idExamenEjecucion
                    }
                    const califica = await axios.post('https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-examen/interoperabilidad/servicios/calificarExamenTeorico', data);

                    califica.status === 200 ? console.log("Success") : console.log (califica.error);
                }

                return data[0]
            } catch ($error) {
                // this.myMethod();
                console.log($error, 'An error has ocurred');
                this.toast.error("Ha ocurrido un error, por favor inténtalo nuevamente", {
                    timeout: 5000,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    closeOnClick: false
                });

            }
        },


        //Validar si la respuesta seleccionada debe actualizarse o guardarse 
        validateQuestionResponse({ IdBancoPregun, IdRespuesta }) {
            this.$store.getters.validateQuestionResponses(IdBancoPregun)
                ? this.updateQuestionResponse({ IdBancoPregun, IdRespuesta })
                : this.saveQuestionResponse({ "IdBancoPregun": this.picked[0], "IdRespuesta": this.picked[1] })
        },

        //Guardar en store la respuesta seleccionada 
        saveQuestionResponse(newResponse) {
            this.$store.commit('setQuestionResponses', newResponse);
            this.$store.state.contadorPreguntas++;
            // console.log('contadorPreguntas:', this.$store.state.contadorPreguntas);
        },
        
        saveResponse(respon) {
            this.$store.commit('setResponses', respon);
        },

        //Actualizar en store la respuesta seleccionada 
        updateQuestionResponse(updatedResponse) {
            this.$store.commit('updateQuestionResponses', updatedResponse);
            // console.log('actualizó')
            // console.log(this.$store.state.isQuestionAnswered, 'actua')
        },

        //Obtener fecha de finalización del examen 
        getDateFinish() {
            let date = new Date();
            let hours = date.getHours();
            let hour = (hours % 12) || 12
            hour < 10 ? hour = ('0' + hour) : hour;

            let seconds = date.getSeconds();
            seconds < 10 ? seconds = ('0' + seconds) : seconds;

            let minutes = date.getMinutes();
            minutes < 10 ? minutes = ('0' + minutes) : minutes;

            const currentHour = hour + ':' + minutes + ':' + seconds;
            // console.log(currentHour);

            let day = date.getDate();
            day < 10 ? day = ('0' + day) : day;
            let month = date.getMonth() + 1;
            month < 10 ? month = ('0' + month) : month;

            let year = date.getFullYear();
            let fecha = `${year}-${month}-${day}`;
            // let output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();

            this.$store.state.contadorPreguntas === this.NUMBER_PREGUNTAS
                ? this.$store.commit('setExamenCompletado', 'true')
                : this.$store.commit('setExamenCompletado', 'false')

            this.$store.commit('setFechaFin', fecha);
            this.$store.commit('setFechaFinSesion', { fecha, currentHour })
        },

    }
}

